import React from "react";
import { Typography } from "@mui/material";
import SideDrawer from "@components/SimpleSideDrawer/SideDrawer";
import { useTranslation } from "react-i18next";
import { useGatedOpen } from "../hooks/usePollingGate";
import { L_TOLERANCE } from "./closeOutSchemas";
import ToleranceChangeList from "./ToleranceChangeList";

const L = `${L_TOLERANCE}.history`;

const ToleranceHistoryPanel: React.FC<{
  operationId: string;
  shipperCode: string;
  onClose: () => void;
}> = ({ operationId, shipperCode, onClose }) => {
  const { t } = useTranslation();
  useGatedOpen(true);
  return (
    <SideDrawer
      isOpen
      title={t(`${L}.title`)}
      onClose={onClose}
      onSubmit={onClose}
      hideCancelButton
      submitLabel={t(`${L}.close`)}
    >
      <div className="w-[480px] max-w-[100vw] flex flex-col gap-3 px-6 py-2">
        <Typography variant="subtitle1" data-testid="tolerance-history-shipper">
          {shipperCode}
        </Typography>
        <ToleranceChangeList operationId={operationId} shipperCode={shipperCode} />
      </div>
    </SideDrawer>
  );
};

export default ToleranceHistoryPanel;
